/* eslint-disable no-nested-ternary */
import { TextField, TextFieldProps } from '@material-ui/core';
import { useMemo, useState } from 'react';
import './LinkField.style.css';

const LinkField: React.FC<TextFieldProps> = ({
  value,
  onBlur,
  onFocus,
  onChange,
  autoComplete = 'off',
  ...textFieldProps
}) => {
  const [isFocused, setIsFocused] = useState(false);

  const valueIsLink = useMemo(() => {
    const regex = /^(https?:\/\/)?([\w-]+\.)+[\w-]+(\/[\w-.,@?^=%&:/~+#]*)?$/i;
    return typeof value === 'string' && regex.test(value);
  }, [value]);

  const classNameInput = useMemo(
    () =>
      `LinkField-input ${valueIsLink && 'is-link'} ${
        !isFocused && 'focus-out'
      }`,
    [valueIsLink, isFocused]
  );

  return (
    <div className="LinkField-container">
      <TextField
        value={value}
        onChange={onChange}
        onFocus={e => {
          onFocus?.(e);
          setIsFocused(true);
        }}
        onBlur={e => {
          onBlur?.(e);
          setIsFocused(false);
        }}
        inputProps={{
          ...textFieldProps?.inputProps,
          className: `${classNameInput} ${textFieldProps?.inputProps?.className}`,
        }}
        autoComplete={autoComplete}
        {...textFieldProps}
      />
      {valueIsLink && !isFocused && (
        // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
        <div
          className="LinkField-text"
          onClick={() => valueIsLink && window.open(value as string)}
        >
          {value as React.ReactNode}
        </div>
      )}
    </div>
  );
};

export default LinkField;
